import { InjectionToken } from '@angular/core';

export const SERVER_REQUEST_URL = new InjectionToken<string>('SERVER_REQUEST_URL');
export const SERVER_REQUEST_ORIGIN = new InjectionToken<string>('SERVER_REQUEST_ORIGIN');
export const SERVER_REQUEST = new InjectionToken<string>('SERVER_REQUEST');
